module.exports = __webpack_public_path__ + "img/17.5adf504b.webp";